import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "De Toiletman completely transformed our bathroom! The team was professional, clean, and finished on time. Highly recommend!",
    name: "Garima Gupta",
    city: "Amsterdam",
    project: "Bathroom Renovation",
  },
  {
    quote:
      "Fast, reliable, and affordable plumbing service. They fixed our issue quickly and explained everything clearly. Will definitely use again!",
    name: "Niharika Sinha",
    city: "Uithoorn",
    project: "Plumbing",
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      className="bg-white py-20 lg:py-28"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-orange-500">
            Wat klanten zeggen
          </p>
          <h2 className="font-display font-bold mt-3 text-4xl sm:text-5xl tracking-tight text-slate-900">
            Beoordeeld met een{" "}
            <span className="text-blue-700">4.9 / 5</span>.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Eerlijke service, duidelijke communicatie en strak vakwerk —
            dat is wat onze klanten waarderen.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              className="relative p-8 sm:p-10 rounded-3xl bg-slate-50 border border-slate-200 hover:border-blue-700 transition-colors"
              data-testid={`review-${i}`}
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-blue-700/15" />
              <div className="flex gap-1" aria-label="5 sterren">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    className="w-4 h-4 fill-orange-500 text-orange-500"
                  />
                ))}
              </div>
              <p className="mt-5 text-lg sm:text-xl text-slate-800 leading-relaxed font-medium">
                &ldquo;{r.quote}&rdquo;
              </p>
              <div className="mt-7 pt-6 border-t border-slate-200 flex items-center gap-4">
                <div
                  className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-700 text-white flex items-center justify-center font-display font-bold text-lg"
                  aria-hidden
                >
                  {r.name
                    .split(" ")
                    .map((n) => n[0])
                    .slice(0, 2)
                    .join("")}
                </div>
                <div>
                  <div className="font-display font-bold text-slate-900">
                    {r.name}
                  </div>
                  <div className="text-sm text-slate-500">
                    {r.city} · {r.project}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
